function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("radialGradient", {
  id: "hotDogMain-radial-gradient",
  cx: -1099.3,
  cy: 745.86,
  r: 5.49,
  gradientTransform: "matrix(0, 1, -0.6, 0, 536.99, 1159.84)",
  gradientUnits: "userSpaceOnUse"
}, React.createElement("stop", {
  offset: 0,
  stopColor: "#fff"
}), React.createElement("stop", {
  offset: 0.26,
  stopColor: "#fdfdfd"
}), React.createElement("stop", {
  offset: 0.4,
  stopColor: "#f5f5f5"
}), React.createElement("stop", {
  offset: 0.5,
  stopColor: "#e7e7e7"
}), React.createElement("stop", {
  offset: 0.6,
  stopColor: "#d4d4d4"
}), React.createElement("stop", {
  offset: 0.68,
  stopColor: "#bbb"
}), React.createElement("stop", {
  offset: 0.76,
  stopColor: "#9c9c9c"
}), React.createElement("stop", {
  offset: 0.83,
  stopColor: "#787878"
}), React.createElement("stop", {
  offset: 0.9,
  stopColor: "#4d4d4d"
}), React.createElement("stop", {
  offset: 0.96,
  stopColor: "#1f1f1f"
}), React.createElement("stop", {
  offset: 1
}));

var _ref3 =
/*#__PURE__*/
React.createElement("radialGradient", {
  id: "hotDogMain-radial-gradient-2",
  cx: -1126.31,
  cy: 745.86,
  r: 5.49,
  gradientTransform: "matrix(0, 1, -0.6, 0, 509.86, 1187.17)",
  xlinkHref: "#hotDogMain-radial-gradient"
});

var SvgHotdogMain = function SvgHotdogMain(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    id: "hotdog-main",
    viewBox: "0 0 207.32 231.03",
    ref: svgRef
  }, props), React.createElement("defs", null, _ref2, _ref3, React.createElement("clipPath", {
    id: "clip-path"
  }, React.createElement("path", {
    d: "M109.83,14.83l-.07,0,.07-.08c.8-1.49-2.26-4.69-6.84-7.15s-8.94-3.23-9.74-1.75a.36.36,0,0,1,0,.11h0L86.69,18.06h0l-.07.08c-.8,1.49,2.27,4.69,6.85,7.15s8.93,3.24,9.74,1.74l0-.1.06,0Z",
    style: {
      fill: "none"
    }
  }))), React.createElement("rect", {
    id: "bun",
    x: 32.39,
    y: 43.1,
    width: 107.59,
    height: 162.74,
    rx: 50.2,
    style: {
      fill: "#dbcb86",
      stroke: "#010101",
      strokeMiterlimit: 10
    }
  }), React.createElement("g", {
    id: "feet"
  }, React.createElement("path", {
    d: "M106.23,171.17s1.8,17.23-1.44,19.43c-2.5,1.71-1.67-4.83-1.67-4.83l-.57,34.16a44,44,0,0,1,6.31,2.54c3.67,1.78,5.88,6.61,5.88,6.61l-24.33.14L92,220.33,91,188.56s-3.44.4-5,.4-4.62-.14-4.62-.14l-.32,31.69.42,8.6H57.83a67.22,67.22,0,0,1,5.79-6.28c2-1.63,6.73-2.87,6.73-2.87l-.75-32.67s1.12.8-5.4-3.65c-5.35-3.64,3.24-6.81,3.24-6.81Z",
    style: {
      fill: "#cd7929",
      stroke: "#73261d",
      strokeMiterlimit: 10,
      strokeWidth: 2
    }
  }), React.createElement("polygon", {
    points: "69.14 218.21 69.14 214.72 82.35 215.35 82.41 218.21 69.14 218.21",
    style: {
      fill: "#fff"
    }
  }), React.createElement("polygon", {
    points: "103.93 218.21 103.93 213.68 90.71 214.5 90.66 218.21 103.93 218.21",
    style: {
      fill: "#fff"
    }
  }), React.createElement("path", {
    d: "M82.41,218.21l.49,12H55.69s4.38-6.49,6.65-8.77,7.74-4,7.74-4Z",
    style: {
      fill: "#2b348c"
    }
  }), React.createElement("path", {
    d: "M62.34,221.46s4.79,3.95,4.79,8.37H55.69S58,222,62.34,221.46Z",
    style: {
      fill: "#5594cf"
    }
  }), React.createElement("rect", {
    x: 55.38,
    y: 229.22,
    width: 27.51,
    height: 1.81,
    style: {
      fill: "#fff"
    }
  }), React.createElement("path", {
    d: "M103.93,217s1.7,1.14,5.93,3.67,6.78,9.38,6.78,9.38l-28,.21,1.79-12.63Z",
    style: {
      fill: "#2b348c"
    }
  }), React.createElement("path", {
    d: "M110.16,221.46s-4.8,3.95-4.8,8.37h11.45S114.46,222,110.16,221.46Z",
    style: {
      fill: "#5594cf"
    }
  }), React.createElement("rect", {
    x: 88.6,
    y: 229.22,
    width: 28.04,
    height: 1.81,
    style: {
      fill: "#fff"
    }
  })), React.createElement("g", {
    id: "body-main"
  }, React.createElement("g", {
    id: "arm-left-group"
  }, React.createElement("path", {
    id: "arm-left",
    d: "M125.07,114.18l19.48-12.92a11.2,11.2,0,0,0,5.21,1.1c3.05-.08,4-1.38,4-1.38l6.45.46a3.07,3.07,0,0,0,2.45-1,14.31,14.31,0,0,0,1.82-6.73c0-2-.91-3-2.16-4.55-.82-1-2-3.17-3.58-3.23s-8.14,3.26-8.14,3.26,3.73-5.48,1.47-6.59-4.49.14-5.44,2.91a15.19,15.19,0,0,0-4.73,3.75C140.4,91.38,141,96,141,96s-13.52,9-19.64,13.11l-11.28-9.29-7.82,1.07,16.28,14.53S121.52,119.52,125.07,114.18Z",
    style: {
      fill: "#cd7929",
      stroke: "#73261d",
      strokeLinejoin: "round",
      strokeWidth: 2
    }
  }), React.createElement("g", {
    id: "flag"
  }, React.createElement("g", {
    id: "fabric"
  }, React.createElement("path", {
    d: "M207.32,63s-.08-1.56-.14-3.94l0,4.11A1.06,1.06,0,0,0,207.32,63Z",
    style: {
      fill: "#fff"
    }
  }), React.createElement("path", {
    d: "M176.93,61.25A27.85,27.85,0,0,0,185,63.52c8.6,1,10.93.25,15.58-1.16a18.13,18.13,0,0,0,6.6-3.39c0-.85,0-1.8-.07-2.83a24.88,24.88,0,0,1-5.78,2.56c-5.23,1.58-8.15,2.31-17.15,1.3a31.26,31.26,0,0,1-9.12-2.54,18.19,18.19,0,0,0-8.39-1.86c-5.4.21-9.82,3.82-11.16,5,0,1,0,1.84.06,2.66a21.35,21.35,0,0,1,11.34-4.21A21.77,21.77,0,0,1,176.93,61.25Z",
    style: {
      fill: "#fff"
    }
  }), React.createElement("path", {
    d: "M176.55,53.83a27.45,27.45,0,0,0,8.07,2.27c8.6,1,10.93.25,15.57-1.16a17.71,17.71,0,0,0,6.68-3.45l.14.15c0-1,0-2-.06-3a24.79,24.79,0,0,1-5.82,2.59c-5.24,1.59-8.15,2.31-17.15,1.3A31,31,0,0,1,174.86,50a18.22,18.22,0,0,0-8.39-1.86c-5.35.21-9.73,3.75-11.12,5,0,.86,0,1.71.05,2.55a21.19,21.19,0,0,1,11.12-4.06A22,22,0,0,1,176.55,53.83Z",
    style: {
      fill: "#fff"
    }
  }), React.createElement("path", {
    d: "M184.11,37.75a27.43,27.43,0,0,1-5.08-1v3.53a23.84,23.84,0,0,0,4.81,1c8.59.95,10.93.25,15.57-1.16a24.72,24.72,0,0,0,7.29-3.77c0-.8,0-1.55-.05-2.24a24.67,24.67,0,0,1-5.4,2.34C196,38,193.11,38.75,184.11,37.75Z",
    style: {
      fill: "#fff"
    }
  }), React.createElement("path", {
    d: "M183.41,45.17a28.74,28.74,0,0,1-4.35-.84v3.13a23.43,23.43,0,0,0,5.34,1.22c8.6,1,10.93.25,15.58-1.16a17.61,17.61,0,0,0,6.67-3.45l.2.21c0-1.11,0-2.2-.06-3.26a24.72,24.72,0,0,1-6.24,2.84C195.33,45.45,192.41,46.17,183.41,45.17Z",
    style: {
      fill: "#fff"
    }
  }), React.createElement("path", {
    d: "M175.06,57.46A31.26,31.26,0,0,0,184.18,60c9,1,11.92.28,17.15-1.3a24.88,24.88,0,0,0,5.78-2.56l.06,0V51.79l-.15-.15-.14-.15a17.71,17.71,0,0,1-6.68,3.45c-4.64,1.41-7,2.12-15.57,1.16a27.45,27.45,0,0,1-8.07-2.27,22,22,0,0,0-10-2.15,21.19,21.19,0,0,0-11.12,4.06l-.34.24,0,5.07s.17-.17.43-.4c1.34-1.23,5.76-4.84,11.16-5A18.19,18.19,0,0,1,175.06,57.46Z",
    style: {
      fill: "#c6202f"
    }
  }), React.createElement("path", {
    d: "M179,36.7a27.43,27.43,0,0,0,5.08,1c9,1,11.91.28,17.15-1.31a24.67,24.67,0,0,0,5.4-2.34l.44-.25v-4.3l-.3-.31a17.5,17.5,0,0,1-6.67,3.45c-4.65,1.41-7,2.11-15.57,1.16A24,24,0,0,1,179,32.56Z",
    style: {
      fill: "#c6202f"
    }
  }), React.createElement("path", {
    d: "M183.85,41.27a23.84,23.84,0,0,1-4.81-1l0,4.1a28.74,28.74,0,0,0,4.35.84c9,1,11.92.28,17.15-1.31A24.72,24.72,0,0,0,206.8,41l.33-.21,0-4.79-.4.32a24.72,24.72,0,0,1-7.29,3.77C194.78,41.52,192.44,42.22,183.85,41.27Z",
    style: {
      fill: "#c6202f"
    }
  }), React.createElement("path", {
    d: "M207.18,59.06V59h0a18.13,18.13,0,0,1-6.6,3.39c-4.65,1.41-7,2.12-15.58,1.16a27.85,27.85,0,0,1-8.07-2.27,21.77,21.77,0,0,0-10-2.15,21.35,21.35,0,0,0-11.34,4.21l-.49.34,0,4.48.35.35c.06-.06,5.13-5.22,11.61-5.46,3.54-.14,5.78.79,8.39,1.86a31.58,31.58,0,0,0,9.12,2.54c9,1,11.91.28,17.15-1.31a25,25,0,0,0,5.48-2.37v-.57Z",
    style: {
      fill: "#c6202f"
    }
  }), React.createElement("path", {
    d: "M166.32,44.26a21.8,21.8,0,0,1,10,2.15c.88.36,1.77.72,2.73,1.05V44.33l0-4.1V31.67l-.3-.05c-8.94-2.3-9.85-3.49-12.49-3.39a17.16,17.16,0,0,0-11.62,5.31s.17,9.9.33,17.62l.06.61.06,0,0-3.31A21.38,21.38,0,0,1,166.32,44.26Zm2.89-11.45,1.24-.18.54-1.12.56,1.12,1.24.17-.89.88.21,1.22L171,34.33l-1.1.58.21-1.23Zm4.18.45,1.23-.18.55-1.12.56,1.12,1.23.17-.89.88.21,1.23-1.1-.58-1.1.58.2-1.23Zm-1.62,4.48L172,39l-1.11-.58-1.1.58.2-1.23-.89-.86,1.23-.19.55-1.12.56,1.12,1.23.17Zm-3.38.43-1.11-.58-1.1.58.21-1.23-.9-.86,1.23-.19.55-1.12.56,1.12,1.24.17-.9.88Zm-4.52.24-1.11-.57-1.1.58.21-1.23-.9-.87,1.23-.18.55-1.12.56,1.11,1.24.18-.9.87Zm-4.4,1.64-1.11-.58-1.1.59.21-1.23-.9-.87,1.23-.18.55-1.13.56,1.12,1.24.18-.9.87Zm-1.12-4.29-1.1.59.2-1.23-.89-.87,1.23-.18.55-1.13.56,1.12,1.23.18-.89.87.22,1.23Zm4.46-2.28-1.1.58.2-1.23L161,32l1.23-.18.55-1.12.56,1.12,1.23.17-.89.88.22,1.23Zm5.15,0-1.1-.58-1.11.59.21-1.23-.89-.87,1.23-.18.55-1.13.55,1.12,1.24.18-.89.87Zm-9.82,10.17-1.1.58.21-1.23-.9-.87,1.24-.18.55-1.12.55,1.12,1.24.17L159,43l.21,1.23Zm4.52-1.52-1.1.58.2-1.23-.89-.87,1.23-.18.55-1.12.56,1.11,1.23.18-.89.87.22,1.23Zm4.64-.48-1.11.58L166.4,41l-.9-.87,1.24-.18.55-1.12.55,1.12,1.24.17-.89.88.21,1.23Zm4.06.68-1.11.58.21-1.23-.9-.86,1.24-.19.55-1.12.55,1.12,1.24.17-.89.88.21,1.23Zm5,1.84-1.11-.58-1.1.59.2-1.23-.89-.87,1.23-.19.55-1.12.56,1.12,1.23.18-.89.87Zm-.13-4.87-1.11-.58-1.1.59.2-1.23-.89-.87,1.23-.18.55-1.13.56,1.12,1.23.18-.89.87Z",
    style: {
      fill: "#2b348c"
    }
  }), React.createElement("path", {
    d: "M174.86,50A31,31,0,0,0,184,52.58c9,1,11.91.29,17.15-1.3A24.79,24.79,0,0,0,207,48.69l.2-.12v-4l-.28-.28-.2-.21A17.61,17.61,0,0,1,200,47.52c-4.65,1.41-7,2.12-15.58,1.16a23.43,23.43,0,0,1-5.34-1.22c-1-.33-1.85-.69-2.73-1.05a21.8,21.8,0,0,0-10-2.15A21.38,21.38,0,0,0,155,48.43l0,3.31v1.72l.3-.27c1.39-1.26,5.77-4.8,11.12-5A18.22,18.22,0,0,1,174.86,50Z",
    style: {
      fill: "#c6202f"
    }
  }), React.createElement("polygon", {
    points: "159.24 35.11 160.13 34.24 158.9 34.06 158.34 32.95 157.79 34.07 156.56 34.25 157.46 35.12 157.25 36.35 158.35 35.76 159.46 36.34 159.24 35.11",
    style: {
      fill: "#fff"
    }
  }), React.createElement("polygon", {
    points: "163.7 32.83 164.59 31.95 163.36 31.78 162.8 30.66 162.25 31.78 161.02 31.96 161.91 32.83 161.71 34.06 162.81 33.48 163.92 34.06 163.7 32.83",
    style: {
      fill: "#fff"
    }
  }), React.createElement("polygon", {
    points: "167.41 31.2 166.85 30.08 166.3 31.2 165.06 31.39 165.96 32.26 165.75 33.49 166.86 32.9 167.97 33.48 167.75 32.25 168.64 31.38 167.41 31.2",
    style: {
      fill: "#fff"
    }
  }), React.createElement("polygon", {
    points: "169.9 34.91 171 34.33 172.11 34.91 171.9 33.67 172.79 32.8 171.55 32.63 170.99 31.51 170.45 32.63 169.21 32.81 170.11 33.68 169.9 34.91",
    style: {
      fill: "#fff"
    }
  }), React.createElement("polygon", {
    points: "174.07 35.36 175.18 34.78 176.28 35.35 176.07 34.13 176.96 33.25 175.72 33.08 175.17 31.96 174.62 33.08 173.39 33.26 174.28 34.13 174.07 35.36",
    style: {
      fill: "#fff"
    }
  }), React.createElement("polygon", {
    points: "160.15 37.95 158.91 37.77 158.35 36.65 157.81 37.77 156.57 37.96 157.47 38.83 157.26 40.06 158.36 39.47 159.47 40.05 159.25 38.82 160.15 37.95",
    style: {
      fill: "#fff"
    }
  }), React.createElement("polygon", {
    points: "159.93 42.12 158.69 41.95 158.13 40.83 157.59 41.95 156.35 42.13 157.25 43 157.04 44.23 158.14 43.65 159.25 44.23 159.04 43 159.93 42.12",
    style: {
      fill: "#fff"
    }
  }), React.createElement("polygon", {
    points: "164.44 40.6 163.21 40.42 162.65 39.31 162.1 40.43 160.87 40.61 161.76 41.48 161.56 42.71 162.66 42.13 163.77 42.7 163.55 41.47 164.44 40.6",
    style: {
      fill: "#fff"
    }
  }), React.createElement("polygon", {
    points: "164.54 36.31 163.31 36.13 162.75 35.02 162.21 36.14 160.97 36.32 161.87 37.19 161.66 38.42 162.76 37.84 163.87 38.41 163.65 37.18 164.54 36.31",
    style: {
      fill: "#fff"
    }
  }), React.createElement("polygon", {
    points: "169.06 36.06 167.83 35.89 167.27 34.77 166.72 35.89 165.49 36.08 166.39 36.94 166.18 38.17 167.28 37.59 168.39 38.17 168.17 36.94 169.06 36.06",
    style: {
      fill: "#fff"
    }
  }), React.createElement("polygon", {
    points: "169.08 40.12 167.84 39.95 167.29 38.83 166.74 39.95 165.5 40.13 166.4 41 166.19 42.23 167.3 41.65 168.4 42.23 168.19 40.99 169.08 40.12",
    style: {
      fill: "#fff"
    }
  }), React.createElement("polygon", {
    points: "172.25 41.68 173.14 40.8 171.9 40.63 171.35 39.51 170.8 40.63 169.56 40.81 170.46 41.68 170.25 42.91 171.35 42.33 172.46 42.91 172.25 41.68",
    style: {
      fill: "#fff"
    }
  }), React.createElement("polygon", {
    points: "177.08 42.07 175.85 41.89 175.29 40.77 174.74 41.89 173.51 42.08 174.41 42.95 174.2 44.18 175.3 43.59 176.41 44.17 176.19 42.94 177.08 42.07",
    style: {
      fill: "#fff"
    }
  }), React.createElement("polygon", {
    points: "176.95 37.2 175.72 37.02 175.16 35.91 174.61 37.03 173.38 37.21 174.27 38.08 174.07 39.31 175.17 38.72 176.28 39.3 176.06 38.07 176.95 37.2",
    style: {
      fill: "#fff"
    }
  }), React.createElement("polygon", {
    points: "170.87 35.57 170.32 36.69 169.09 36.88 169.98 37.74 169.78 38.98 170.88 38.39 171.99 38.97 171.77 37.74 172.66 36.86 171.43 36.69 170.87 35.57",
    style: {
      fill: "#fff"
    }
  })), React.createElement("path", {
    id: "pole",
    d: "M157.59,29.06a3.92,3.92,0,1,0-7.84,0,3.89,3.89,0,0,0,1.89,3.32l.23,73.2,4.09,0-.23-73.19A3.9,3.9,0,0,0,157.59,29.06Z",
    style: {
      fill: "#9fa09f"
    }
  }))), React.createElement("path", {
    id: "arm-right",
    d: "M42,114.22,21.46,103a11.18,11.18,0,0,1-5.1,1.52c-3,.18-4.06-1-4.06-1l-6.38,1a3,3,0,0,1-2.52-.76A14.29,14.29,0,0,1,1,97.15c-.14-2,.66-3,1.78-4.72.72-1.1,1.68-3.32,3.29-3.51s8.39,2.57,8.39,2.57-4.18-5.15-2-6.45,4.48-.23,5.67,2.45a15.23,15.23,0,0,1,5,3.34c1.61,2,1.44,6.63,1.44,6.63s13.59,7.16,20,10.74l17-7.07,2,7.08-17.74,7.73S44.31,116.55,42,114.22Z",
    style: {
      fill: "#cd7929",
      stroke: "#73261d",
      strokeLinejoin: "round",
      strokeWidth: 2
    }
  }), React.createElement("rect", {
    id: "body",
    x: 57.18,
    y: 19.18,
    width: 54.14,
    height: 180.88,
    rx: 25.26,
    transform: "translate(-1.24 0.96) rotate(-0.65)",
    style: {
      fill: "#cd7929",
      stroke: "#73261d",
      strokeMiterlimit: 10,
      strokeWidth: 2
    }
  }), React.createElement("g", {
    id: "eye-left"
  }, React.createElement("path", {
    d: "M106.89,62.34c.09,6.91-4.15,12.57-9.46,12.63s-9.69-5.49-9.77-12.4S91.81,50,97.13,49.94,106.81,55.43,106.89,62.34Z",
    style: {
      fill: "#fff"
    }
  }), React.createElement("path", {
    d: "M102.84,62.87c.06,4.38-2.35,8-5.36,8S92,67.38,91.92,63s2.35-8,5.37-8S102.79,58.49,102.84,62.87Z",
    style: {
      fill: "url(#hotDogMain-radial-gradient)"
    }
  })), React.createElement("g", {
    id: "eye-right"
  }, React.createElement("path", {
    d: "M79.89,62.66c.09,6.91-4.15,12.57-9.46,12.63s-9.69-5.48-9.77-12.4,4.15-12.56,9.47-12.63S79.81,55.75,79.89,62.66Z",
    style: {
      fill: "#fff"
    }
  }), React.createElement("path", {
    d: "M75.84,63.19c.06,4.38-2.35,8-5.36,8S65,67.7,64.92,63.32s2.35-8,5.37-8S75.79,58.81,75.84,63.19Z",
    style: {
      fill: "url(#hotDogMain-radial-gradient-2)"
    }
  })), React.createElement("g", {
    id: "bowtie"
  }, React.createElement("path", {
    d: "M72.32,114.25a2.52,2.52,0,0,1-2.49-2.53l.09-8.8a2.51,2.51,0,0,1,2.53-2.49l11.19,4.65,0,3.81Z",
    style: {
      fill: "#5594cf"
    }
  }), React.createElement("path", {
    d: "M97.23,114.48A2.51,2.51,0,0,0,99.76,112l.08-8.8a2.5,2.5,0,0,0-2.48-2.53l-11.28,4.44,0,3.8Z",
    style: {
      fill: "#5594cf"
    }
  }), React.createElement("path", {
    d: "M89.65,107.2a4.92,4.92,0,1,1-4.87-5A4.91,4.91,0,0,1,89.65,107.2Z",
    style: {
      fill: "#2b348c"
    }
  })), React.createElement("g", {
    id: "mouth"
  }, React.createElement("path", {
    d: "M75.14,79.45s3.32,5.12,8.63,5.61,8.4-6.17,8.4-6.17Z",
    style: {
      fill: "#010101"
    }
  }), React.createElement("path", {
    d: "M86.9,84.38a9.36,9.36,0,0,0,.6-1.88,3.45,3.45,0,0,0-.22-1,.76.76,0,0,0-.78-.64c-.79-.06-1.62-.05-1.87.87-.06.22.16,1.22-.33,1.07-.19-.06-.41-.66-.49-.82-.36-.71-.93-1.24-1.77-.9a1.33,1.33,0,0,0-.74.8c-.22.52-.08.57,0,1.08a4.37,4.37,0,0,0,.21,1.16c.06.15.17.33.26.51a9.4,9.4,0,0,0,2,.42,6,6,0,0,0,3.09-.53A1,1,0,0,1,86.9,84.38Z",
    style: {
      fill: "#c6202f"
    }
  })), React.createElement("g", {
    id: "hat"
  }, React.createElement("g", null, React.createElement("path", {
    d: "M107,32.09c-.86,1.6-7.35-.21-14.49-4.05s-12.25-8.23-11.4-9.83,7.35.22,14.5,4.05S107.8,30.5,107,32.09Z",
    style: {
      fill: "#fff"
    }
  }), React.createElement("path", {
    d: "M109.78,15l-.06,0,.07-.08c.8-1.49-2.27-4.7-6.84-7.15S94,4.49,93.21,6a.49.49,0,0,0,0,.11h0L86.64,18.23h0l-.07.09c-.8,1.49,2.27,4.69,6.84,7.15s8.94,3.23,9.74,1.74a.42.42,0,0,0,0-.1l.06,0Z",
    style: {
      fill: "#fff"
    }
  }), React.createElement("g", {
    style: {
      clipPath: "url(#clip-path)"
    }
  }, React.createElement("rect", {
    x: 79,
    y: 9.43,
    width: 24.17,
    height: 4.61,
    transform: "translate(37.63 86.41) rotate(-61.75)",
    style: {
      fill: "#c6202f"
    }
  }), React.createElement("rect", {
    x: 94.13,
    y: 17.96,
    width: 24.17,
    height: 4.61,
    transform: "translate(38.08 104.23) rotate(-61.75)",
    style: {
      fill: "#c6202f"
    }
  }), React.createElement("rect", {
    x: 86.96,
    y: 13.16,
    width: 24.17,
    height: 4.61,
    transform: "translate(38.54 95.4) rotate(-61.75)",
    style: {
      fill: "#c6202f"
    }
  })), React.createElement("g", null, React.createElement("path", {
    d: "M89,13.84a.47.47,0,0,1,.06-.09h0Z",
    style: {
      fill: "#2b348c"
    }
  }), React.createElement("path", {
    d: "M105.61,22.63a.42.42,0,0,1,0,.1c-.79,1.49-5.16.71-9.73-1.75S88.2,15.33,89,13.84l-2.28,4.24h0a.31.31,0,0,0-.07.09c-.8,1.49,2.26,4.69,6.84,7.14s8.94,3.24,9.74,1.75a.35.35,0,0,0,0-.11l.07,0",
    style: {
      fill: "#2b348c"
    }
  }), React.createElement("path", {
    d: "M93.29,5.83h0Z",
    style: {
      fill: "#2b348c"
    }
  }))), React.createElement("ellipse", {
    cx: 101.99,
    cy: 9.48,
    rx: 2.69,
    ry: 9.39,
    transform: "translate(45.16 94.7) rotate(-61.61)",
    style: {
      fill: "#fff"
    }
  })), React.createElement("g", {
    id: "ketchup"
  }, React.createElement("path", {
    d: "M85.26,116.87C82,120,77.36,121.47,74.48,125a11.39,11.39,0,0,0-2.2,10.15c1,4.11,4.83,7.52,8.23,9.74,3.76,2.46,10.3,4.41,10.63,9.77s-8.2,8.56-12,11.09c-3.54,2.37-6.7,6-7.52,10.29-1.95,10.17,9,14.77,15.87,19,3.82,2.34,7.31-3.66,3.5-6s-8.06-3.55-10.93-7.23c-3.71-4.74.41-8.71,4.51-11.2,6-3.63,14.68-8.39,13.74-16.77s-8.45-11-14.3-14.94c-3.8-2.58-7.56-7.27-2.69-10.77,3-2.13,6.19-3.79,8.85-6.37,3.21-3.12-1.71-8-4.92-4.91Z",
    style: {
      fill: "#c6202f"
    }
  })), React.createElement("path", {
    id: "eyebrow-right",
    d: "M66.53,45.39a4.82,4.82,0,0,1,3.63-2.22,3.75,3.75,0,0,1,3.28,2",
    style: {
      fill: "none",
      stroke: "#010101",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 3
    }
  }), React.createElement("path", {
    id: "eyebrow-left",
    d: "M94.88,44.58a4.82,4.82,0,0,1,3.63-2.22,3.72,3.72,0,0,1,3.27,2",
    style: {
      fill: "none",
      stroke: "#010101",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 3
    }
  })));
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgHotdogMain, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/hotdog-main.f7f9006c.svg";
export { ForwardRef as ReactComponent };